export default "__VITE_ASSET__Ci3cX9vV__"